// extracted by mini-css-extract-plugin
module.exports = {"container":"BrandSlider-module__container___1I2Yn","slide":"BrandSlider-module__slide___120QX"};